import angular from "angular";
import { directiveFactory } from "../../angular-core";

export class MarketDefinitionNameUniqueDirective implements ng.IDirective {
    static componentName: string = "marketDefinitionNameUnique";
    static $inject = ["$http", "$q"];

    require = "ngModel";
    restrict = "A";

    link = (scope: $TSFixMe, element: JQLite, attrs: ng.IAttributes, ngModel: $TSFixMe) => {
        ngModel.$asyncValidators.marketDefinitionNameUnique = (modelValue: $TSFixMe, viewValue: $TSFixMe) => {
            var value = modelValue || viewValue;
            return this.$http({
                method: "GET",
                url: "/api/market-definition/unique",
                params: {
                    name: value,
                    id: scope.$eval(attrs.marketDefinitionId)
                }
            }).then(
                (response: $TSFixMe) => {
                    if (response.data) {
                        return true;
                    }
                    return this.$q.reject("exists");
                },
                () => {
                    return false;
                }
            );
        };
    };

    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService) {}
}

angular
    .module("topline.directives")
    .directive(
        MarketDefinitionNameUniqueDirective.componentName,
        directiveFactory(MarketDefinitionNameUniqueDirective)
    );
